/**  
 * 动态菜单=》动态权限
*/
const map_path_permission = new Map();//页面路径和功能权限的映射关系
const authorityMap = {};//经过筛选后的最终映射关系

const deepFunc = (arr) => {
    arr.forEach(item => {
        let { menuPath, subMenuList } = item;
        if (Array.isArray(subMenuList)) {
            deepFunc(subMenuList);
        }
        let menuTypeArr = subMenuList.filter(temp => temp.menuType == 1);//提取权限
        menuTypeArr = menuTypeArr.map(it => it.permissionCode);
        // /sys/menu => auth_sys_menu
        menuPath = ('' + menuPath).replaceAll(/\//g, "_")//TODO：UC浏览器没有这个方法，需要自定义实现兼容
        menuPath = 'auth_' + menuPath;
        map_path_permission.set(menuPath, menuTypeArr);
    })
}
function filterEmpty() {
    //筛选无权限的路径
    const entry = map_path_permission.entries();
    for (const iterator of entry) {
        const key = iterator[0];
        const value = iterator[1];
        if (Array.isArray(value) && value.length != 0) {
            authorityMap[key] = value;
        }
    }
}

export default (apiMenuArr = []) => {
    deepFunc(apiMenuArr);
    filterEmpty();
    return authorityMap;
}





// WEBPACK FOOTER //
// ./src/utils/renderAuthority.js